export const Note = ({
  children,
  intent,
  className,
}: { children: React.ReactNode; intent: "info" | "danger"; className: string }) => {
  const color = {
    info: "border-primary-500 bg-primary-110",
    danger: "border-red-400 bg-red-700",
  }[intent];

  return <div className={`rounded-md border-2 m-4 p-4 text-lg ${color} ${className}`}>{children}</div>;
};
